module.exports = __webpack_public_path__ + "img/bory-video-cover.602ba3b3.jpeg";